import { CreditAlert } from '../../shared/interfaces/ICreditAlert';

export interface IBuyerErrorModal {
    bodyText?: string;
    title?: string;
    isShown?: boolean;
    creditAlert?: CreditAlert;
}
